<script>
	import { getText } from '../../../../share/utils';
</script>

<div>
	<div class="flex structure marginbox">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="responsive Design eines Kathi-Gewinnspiels"
					 src="./../img/10.Appetit_Digitalisieren/06.ad_ad_hurra/kathi_landing.webp">
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex structure-2-1 paddingbox_right">
				<div class="flex element">
					<div class="content row">
						<h2>{getText("10.06.01_h2")}</h2>
						<p class="caption">{getText("10.06.02_caption")}</p>
						<p class="caption blue">Project Lead: <a href="//www.zebra.de" target="_blank">Zebra</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";

	.flex {
		display: flex;
		box-sizing: border-box;
	}
	
	.row {
		flex-flow: row wrap;
	}
	
	.col {
		flex-flow: column wrap;
	}
	
	.element {
		min-width: 100px;
	}
	
	.content {
		flex: 1 100%;
	}
	
	.structure {
		flex-flow: row wrap;
		
		@include for-desktop-up {
			flex-flow: row nowrap;
		}
	}
	
	.structure-1 {
		flex-shrink: 1;
		width: auto;
		margin-top: $spacing-mobile;
		
		@include for-tablet-landscape-up {
			width: 50%;
			margin-top: 0;
			margin-right: $media-gap;
		}
	}
	
	.structure-2 {
		flex-shrink: 0;
		width: 100%;
		justify-content: space-evenly;
		margin-bottom: $spacing-mobile;
		
		@include for-tablet-landscape-up {
			width: 49%;
			margin: 0 auto $spacing-mobile auto;
		}
		
		@include for-desktop-up {
			margin: 0 auto $spacing-mobile auto;
		}
	}
	
	.structure-2-1 {
		margin: $spacing-mobile $spacing-mobile 0 $spacing-mobile;
		
		@include for-tablet-landscape-up {
			margin: $media-gap $media-gap 0 0;
		}
	}
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	h2 {
		margin-bottom: $media-gap;
	}
	
	p:first-of-type {
		margin-bottom: $media-gap;
	}
</style>
